/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 09/05/2025 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Apertura de modal sin animación
* --------------------------------------------------------------------------------------- */

import TextField from "../ui/TextField";
import React, { Fragment, useEffect, useRef, useState, useCallback } from "react";
import PersonIcon from "@mui/icons-material/PersonOutline";
import KeyIcon from "@mui/icons-material/LockOutlined";

import { apiLoginValidator } from "../../settings/ApiConfig";
import { Modal, Box, InputAdornment, Button, InputLabel } from "@mui/material";

import { handleValidarStrings, isNullOrEmpty } from "../../settings/utils";
import { useSesion } from "../../context/System/SesionContext";
import { useLayout } from "../../context/System/LayoutContext";
import { useVentas } from "../../context/Ventas/VentasContext";

const modalStyle = {
  position: "fixed",
  top: "30%",
  right: "39%",
  width: "369px",
  height: "390px",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  display: "flex",
  flexDirection: "column",
  borderRadius: "12px",
};

export default function FrmLoginValidate(props) {
  const {
    openModal,
    hancleCloseModalValidator,
    tiposUsuario = ["SA", "ADMINISTRADOR"],
    handleComandoEjecucion,
  } = props;

  const { handleOpenAlert } = useLayout();
  const { tokenSeguridad } = useSesion();
  const { setStatusKeyActions } = useVentas();

  const [sesionName, setSesionName] = useState("");
  const [sesionPassword, setSesionPassword] = useState("");
  const [passwordFocused, setPasswordFocused] = useState(false);

  const userRef = useRef(null);
  const passRef = useRef(null);

  const handleSubmitLoginForm = useCallback(async () => {
    if (isNullOrEmpty(sesionName) || isNullOrEmpty(sesionPassword)) return;

    const loginRequest = { sUser: sesionName, sPassword: sesionPassword };

    try {
      const tenantAccessTokenName = "sizesoftx-tenant-access-token";
      const tenantAccessToken = localStorage.getItem(tenantAccessTokenName);
      const loginResponse = await fetch(apiLoginValidator, {
        method: "POST",
        body: JSON.stringify(loginRequest),
        headers: {
          'Authorization': `Bearer ${tenantAccessToken || tokenSeguridad}`,
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
        loader: "Validando acceso al sistema"
      });
      const response = await loginResponse.json();

      if (response?.hasError) {
        handleOpenAlert("Error en credenciales de acceso", "error");
        return;
      }

      const tipouser = (response?.result?.TipoUsuario.trim().toUpperCase() ?? "").trim();
      const estadoValidation = tiposUsuario.includes(tipouser);
      //Validación en mayúsculas 


      setSesionName("");
      setSesionPassword("");

      if (estadoValidation) {
        handleComandoEjecucion(true, sesionName);
        hancleCloseModalValidator();
      } else {
        handleOpenAlert("Usuario sin permisos", "error");
      }
    } catch (error) {
      handleOpenAlert(
        "Ocurrió un error inesperado al intentar validar las credenciales: " + String(error),
        "error"
      );
    }
  }, [
    sesionName,
    sesionPassword,
    tokenSeguridad,
    tiposUsuario,
    handleComandoEjecucion,
    hancleCloseModalValidator,
    handleOpenAlert,
  ]);

  useEffect(() => {
    if (openModal) {
      setTimeout(() => {
        setStatusKeyActions(true);
        setTimeout(() => userRef.current?.focus?.(), 0);
      }, 0);
    } else {
      setSesionName("");
      setSesionPassword("");
    }
  }, [openModal, setStatusKeyActions]);

  const handleChangeLoginForm = (e) => {
    const errorValue = handleValidarStrings(e.target.value);
    if (errorValue === "Caracteres no vélidos") {
      handleOpenAlert("Ingreso de caracter no vélido", "error");
      return;
    }

    if (e.target.name === "username") setSesionName(e.target.value);
    if (e.target.name === "password") setSesionPassword(e.target.value);
  };

  
  const handleKeyDownCapture = (e) => {
    if (e.key === "Escape") {
      e.preventDefault();
      e.stopPropagation();
      hancleCloseModalValidator();
      return;
    }

    if (name === "username" && (e.key === "Tab" || e.key === "Enter")) {
      e.preventDefault();
      e.stopPropagation();
      passRef.current?.focus?.();
      return;
    }

    if (e.target === passRef.current) {
      if (e.key === "Enter") {
        e.preventDefault();
        e.stopPropagation();
        handleSubmitLoginForm();
        return;
      }
    }
  };

  return (
    <Modal
      open={openModal}
      onClose={hancleCloseModalValidator}
      aria-labelledby="menu-modal-title"
      aria-describedby="menu-modal-description"
      disableEscapeKeyDown={false}
    >
      <Box
        sx={modalStyle}
        onKeyDownCapture={handleKeyDownCapture}
      >
        <Fragment>
          <div className="mainLogin">
            <div className="detalles-totales-header">
              <h1>Validación permisos</h1>
            </div>

            <div>
              <InputLabel className="lbl" required>
                Usuario
              </InputLabel>
              <TextField
                inputRef={userRef}
                name="username"
                value={sesionName}
                onChange={handleChangeLoginForm}
                autoComplete="off"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PersonIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </div>

            <div>
              <InputLabel className="lbl" required>
                Contraseña
              </InputLabel>
              <TextField
                inputRef={passRef}
                name="password"
                value={sesionPassword}
                onChange={handleChangeLoginForm}
                type="password"
                autoComplete="off"
                readOnly={!passwordFocused}
                onFocus={() => setPasswordFocused(true)}
                onBlur={() => setPasswordFocused(false)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <KeyIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </div>

            <div>
              <Button
                onClick={handleSubmitLoginForm}
                style={{ backgroundColor: "#a9701e", color: "#FFFFFF" }}
                fullWidth
              >
                Entrar
              </Button>
            </div>
          </div>
        </Fragment>
      </Box>
    </Modal>
  );
}
